module.exports = __webpack_public_path__ + "img/6417753b-c7ec-453c-8c3a-cc1aebc9118e.45ece0f4.png";